router-link.fp-dropdown-item(v-if='routeLocation' :to='routeLocation' :id='id' :data-test='dataTest' :class='{"-danger": danger}')
  i.fp-icon.-s12(v-if='icon' :class='`fp-glyph-${icon}`')
  img.fp-illustration.-xs(v-if='image' :class='`-${image}`')
  .fp-dropdown-item--text {{ text }}
a.fp-dropdown-item(v-else :id='id' :data-test='dataTest' target='_blank' :href='href' :class='{"-danger": danger}')
  i.fp-icon.-s12(v-if='icon' :class='`fp-glyph-${icon}`')
  img.fp-illustration.-xs(v-if='image' :class='`-${image}`')
  .fp-dropdown-item--text {{ text }}
